import React from "react";
import "./../../App.css";
// import CloseIcon from "@mui/icons-material/Close";
// import { style } from "@mui/system";

import * as dateFns from "date-fns";
import QRCODE from "qrcode.react";

interface Props {
  theme: "white" | "black" | "blue";
}
const person =
{
  Name: "Mukamurangwa Mupac",
  Contact: 25775623422,
  Rooms: [
    {
      description: "Parent's room VIP"
    },
    { description: "Children's room" }
  ],
  Npeople: 4,
  Arrivaldate: 1666888497462,
  Hotel: "Selena Hotel"
}

const BookingCard: React.FC<Props> = ({ theme }) => {
  return (
    <div className="w-screen  flex flex-col rounded-md pt-8 ">
      <div
        className={`${theme === "white"
            ? "bg-white text-black border-2  border-[#EAEAEA]"
            : theme === "black"
              ? "bg-black text-white"
              : theme === "blue"
                ? " text-white bg-[#6792FF]"
                : "bg-white"
          } flex items-center m-auto justify-between  rounded-xl w-2/3 lg:w-3/12  `}
      >
        <div className="pt-3 pb-3">
          <div id="code" className="" style={{ height: "630px" }}>
            <div className="flex flex-row justify-around items-center  h-16 rounded-t-xl ">
              <div className="text-md bg-red">
                <strong id="head" className="text-md">
                  Murwiza
                </strong>
              </div>
              <div
                className={`${theme === "white" ? "bg-[#F1F1F1]" : theme === "black" ? "bg-[#191919]" : theme === "blue" ? "bg-[#769DFF]" : "bg-black"} h-5 w-5 rounded-xl  self-center `}
              ></div>

              <div className={`${theme === "white" ? "text-[#ECECEC]" : theme === "black" ? "text-[#707070]" : theme === "blue" ? "text-[#A1B6EA]" : "bg-black"}`} >
                {dateFns.format(person.Arrivaldate, "yyyy MM do")}
              </div>
            </div>
            <div
              className={`${theme === "white"
                  ? "bg-[#F9F9F9]"
                  : theme === "black"
                    ? "bg-[#191919] "
                    : theme === "blue"
                      ? "bg-white text-black"
                      : "bg-slate-200"
                } text-center font-bold p-2  border-white  `}
            >
              <strong>Selena Hotel Booking Card</strong>
            </div>
            <div className=" h-5/6 rounded-b-xl flex flex-col justify-evenly">
              <div
                className={`${theme === "white" ? "text-[#D9D9D9]" : theme === "black" ? "text-[#5D5D5D]" : theme === "blue" ? "text-[#98B0ED]" : "bg-black"} text-center p-4 `}

              >
                All the information needed to prove the ownership and booking
                details are in this code
              </div>
              <div className="">
                <QRCODE
                  className="bg-white p-2"
                  value="murwiza.vercel.app/"
                  style={{ margin: "auto", color: "#" }}
                />
              </div>
              <div className={`${theme === "white" ? "text-[#D9D9D9]" : theme === "black" ? "text-[#5D5D5D]" : theme === "blue" ? "text-[#98B0ED]" : "bg-black"} text-center`}>
                For informational purposes or misundertanding contact the
                Murwiza support Team <br />{" "}
                <a
                  href="/"
                  className={`${theme === "white" ? "text-[#C6C6C6]" : theme === "black" ? "text-[#6F6F6F]" : theme === "blue" ? "text-[#9CA9CA]" : "bg-black"} text-center text-sm font-bold `}
                >
                  support@murwiza.rw
                </a>
              </div>

              <div
                className={`${theme === "white" ? "text-[#CACACA]" : theme === "black" ? "text-[#595959]" : theme === "blue" ? "text-[#9CA9CA]" : "bg-black"} text-sm font-bold text-center mt-1 p-2`}
              >
                copyright&copy; murwiza 2022
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingCard;